import { ModalScreenProvider } from "clientState/AuthFlow/providers/ModalScreenProvider";
import { withErrorBoundary } from "@edreamsodigeo/frontend-core";

import withAuthContext from "../withAuthContext";

export default withAuthContext(
  withErrorBoundary(ModalScreenProvider, {
    name: "ModalScreenProvider",
  }),
);
